const global = {
	state: {
		token: '18770965263_97cf340df3b84178beb76ff3a6308c7a',
		alert: {
			message: null,
			confirm: null
		},
		computer: true,
		router: null,
		userInfo: null
	},
	mutations: {
		setAlert(state, payload) {
			state.alert = payload;
		},
		setToken(state, payload) {
			state.token = payload;
		},
		setComputer(state,payload){
			state.computer = payload;
		},
		setRouter(state,payload){
			state.router = payload;
		},
		setUserInfo(state,payload){
			state.userInfo = payload
		}
	}
}

export default global
